import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f5f6486"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-1 flex flex-col md:p-5" }
const _hoisted_2 = { class: "grid grid-rows-auto md:grid-rows-none md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 flex-1 gap-5" }
const _hoisted_3 = { class: "md:col-span-2 lg:col-span-3 xl:col-span-4 relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_paver_picker = _resolveComponent("paver-picker")!
  const _component_render = _resolveComponent("render")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_paver_picker, {
        tiles: _ctx.tiles,
        "onUpdate:tiles": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tiles) = $event)),
        errors: _ctx.errors,
        onGetTiles: _ctx.getTiles
      }, null, 8, ["tiles", "errors", "onGetTiles"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_render, { tiles: _ctx.tiles }, null, 8, ["tiles"])
      ])
    ])
  ]))
}